<template>
  <div class="application-box">
    <div class="header-box">
      <div id="PublicHeader" class="public-header">
        <!-- 导航菜单 -->
        <div class="wise-header">
          <div class="header-nav">
            <!-- Logo -->
            <img class="logo" :src="`${oss_url}/freesailing_logo.png`" />
          </div>
        </div>
      </div>
    </div>

    <div class="application-main" v-if="!isSubmitError">
      <div class="application-card" v-loading="loading">
        <!-- 标题 -->
        <div class="card-title" v-if="configInfo">{{ isEdit ? '补充落货申请' : '提交落货申请' }}</div>

        <div class="card-body" v-if="configInfo">
          <!-- 提示条 -->
          <div v-if="submitted" class="notice-bar notice-bar-success">
            {{ isEdit ? '修改成功，当前链接已失效' : '提交成功，当前链接已失效' }}
          </div>
          <div v-else class="notice-bar notice-bar-create">
            {{ isEdit ? `正在修改原落货申请：${configInfo.houseBillNo}（成功修改后链接失效）` : '当前为一次性落货申请链接（成功提交后失效）' }}
          </div>

          <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-row :gutter="24">
              <!-- 左列：基础信息 -->
              <el-col :span="12">
                <el-form-item label="业务类型" prop="bidType">
                  <el-select size="small" v-model="form.bidType" placeholder="请选择船代" style="width: 100%" disabled>
                    <el-option label="落货申请" value="UNLOAD_CARGO" />
                  </el-select>
                </el-form-item>
                <el-form-item label="船代" prop="shipAgentShow">
                  <el-input size="small" v-model="form.shipAgentShow" disabled></el-input>
                </el-form-item>
                <el-form-item label="分提单号" prop="houseBillNo">
                  <el-input size="small" v-model="form.houseBillNo" placeholder="请输入分提单号（精确匹配）" disabled></el-input>
                </el-form-item>

                <!-- 上海中联 -->
                <template v-if="form.shipAgent == 'SH_ZHONG_LIAN'">
                  <el-form-item label="未上船证明版本" prop="textInputValues.zhongLianNotShippedTarget">
                    <el-select size="small" v-model="form.textInputValues.zhongLianNotShippedTarget" placeholder="请选择未上船证明版本" style="width: 100%" :disabled="submitted">
                      <el-option label="外港海关" value="外港海关" />
                      <el-option label="上海海关" value="上海海关" />
                      <el-option label="上海海事局" value="上海海事局" />
                    </el-select>
                  </el-form-item>
                  <el-form-item label="未上船原因 该未上船原因仅用于《未上船证明》" prop="textInputValues.notShippedReason">
                    <el-input size="small" v-model="form.textInputValues.notShippedReason" type="textarea" resize="none" :rows="4" maxlength="30" placeholder="请输入未上船原因" :disabled="submitted"></el-input>
                  </el-form-item>
                  <el-form-item label="报关单号" prop="textInputValues.customsDeclarationNo">
                    <el-input size="small" v-model="form.textInputValues.customsDeclarationNo" placeholder="请输入报关单号" :disabled="submitted"></el-input>
                  </el-form-item>
                  <!-- 上海海事局 -->
                  <el-form-item v-if="form.textInputValues.zhongLianNotShippedTarget == '上海海事局'" label="申报编号" prop="textInputValues.declarationNo">
                    <el-input size="small" v-model="form.textInputValues.declarationNo" placeholder="请输入申报编号" :disabled="submitted"></el-input>
                  </el-form-item>
                  <el-form-item v-if="form.textInputValues.zhongLianNotShippedTarget == '上海海事局'" label="审核回执号" prop="textInputValues.auditReceiptNo">
                    <el-input size="small" v-model="form.textInputValues.auditReceiptNo" placeholder="请输入报审核回执号" :disabled="submitted"></el-input>
                  </el-form-item>
                </template>

                <!-- 上海联合 / 上海外代 / 上海顺德 / 上海东方海外 -->
                <template v-if="['SH_LIAN_HE', 'SH_WAI_DAI', 'SH_SHUN_DE', 'DF_HAI_WAI'].includes(form.shipAgent)">
                  <!-- 上海外代、上海东方海外 显示 未上船原因 -->
                  <el-form-item v-if="['SH_WAI_DAI', 'DF_HAI_WAI'].includes(form.shipAgent)" :label="notShippedReasonText[form.shipAgent]" prop="textInputValues.notShippedReason">
                    <el-input size="small" v-model="form.textInputValues.notShippedReason" type="textarea" resize="none" :rows="4" maxlength="30" placeholder="请输入未上船原因" :disabled="submitted"></el-input>
                  </el-form-item>

                  <!-- 上海顺德、上海联合 显示 落货申请原因 -->
                  <el-form-item v-if="['SH_SHUN_DE', 'SH_LIAN_HE'].includes(form.shipAgent)" label="落货申请原因" prop="textInputValues.unloadReason">
                    <el-input size="small" v-model="form.textInputValues.unloadReason" type="textarea" resize="none" :rows="4" maxlength="30" placeholder="请输入落货申请原因" :disabled="submitted"></el-input>
                  </el-form-item>

                  <!-- 东方海外 Label显示 关单号  东方海外 不显示 关单号字段 -->
                  <el-form-item v-if="!['DF_HAI_WAI'].includes(form.shipAgent)" :label="`${['DF_HAI_WAI'].includes(form.shipAgent) ? '关单号' : '报关单号'}`" prop="textInputValues.customsDeclarationNo">
                    <el-input size="small" v-model="form.textInputValues.customsDeclarationNo" :placeholder="`请输入${['DF_HAI_WAI'].includes(form.shipAgent) ? '关单号' : '报关单号'}`" :disabled="submitted"></el-input>
                  </el-form-item>
                </template>

                <!-- 上海振华 -->
                <template v-if="['SH_ZHEN_HUA'].includes(form.shipAgent)">
                  <el-form-item label="同箱剩余分提单号（系统带出）" prop="relatedHouseBillNos" style="margin-bottom: 6px">
                    <div class="house-bill-box">
                      <div v-for="item in configInfo?.relatedHouseBillNos || []">分提单号：{{ item }}</div>
                      <div>箱号：{{ configInfo?.containerNo }}</div>
                    </div>
                  </el-form-item>
                  <div class="house-bill-tip">请上传本票及同箱剩余分提单号对应报关单，可一次选择多份。</div>
                </template>

                <el-form-item label="备注" prop="remark">
                  <el-input size="small" v-model="form.remark" maxlength="30" placeholder="最多输入30个字符" :disabled="submitted"></el-input>
                  <!-- <el-input size="small" v-model="form.remark" type="textarea" resize="none" :rows="4" maxlength="30" placeholder="最多输入30个字符" :disabled="submitted"></el-input> -->
                </el-form-item>
              </el-col>

              <!-- 右列：上传资料 -->
              <el-col :span="12">
                <!-- 首次提交：无资料上传项 -->
                <template v-if="!isEdit">
                  <div v-if="!form.shipAgent">
                    <el-form-item label="上传资料" style="margin-bottom: 6px"> </el-form-item>
                  </div>
                  <template v-else>
                    <el-form-item label="上传资料" class="upload-item-form">
                      <div class="upload-item-row upload-info">请按要求上传以下资料：</div>
                    </el-form-item>
                    <el-form-item v-for="item in configFiles" :prop="item.configFileId" :key="item.configFileId" :label="item.fileName" :rules="[{ required: item.requiredFlag, message: '请选择', trigger: 'change' }]" class="upload-item-form">
                      <div class="upload-item-content">
                        <div class="upload-item-row">
                          <el-upload action="" multiple :auto-upload="false" :show-file-list="false" :disabled="submitted || (item.maxCount != null && item.files.length >= Number(item.maxCount))" :accept="formatExtensions(item.fileExtensions)" :on-change="file => handleFileChange(file, item)">
                            <el-button size="mini" type="primary" plain :disabled="submitted || (item.maxCount != null && item.files.length >= Number(item.maxCount))">选择文件</el-button>
                          </el-upload>
                          <span class="upload-file-name" v-if="item.files.length">{{ `已选择 ${item.files.length} 个文件` }}</span>
                          <span class="upload-file-name" v-else style="color: #999">未选择任何文件</span>
                        </div>
                        <!-- 已选文件列表（支持多文件，可单个删除） -->
                        <ul v-if="item.files.length" class="selected-files">
                          <li v-for="(file, fIdx) in item.files" :key="file.uid || file.fileId || file.id || fIdx">
                            <i class="el-icon-document"></i>
                            <span class="file-name" :title="file.fileName">{{ file.fileName }}</span>
                            <span class="file-size">{{ formatSize(file.size || file.fileSize) }}</span>
                            <i v-if="file.uploading" class="el-icon-loading file-status"></i>
                            <i v-else-if="file.uploadError" class="el-icon-warning-outline file-status file-error"></i>
                            <i v-else class="el-icon-circle-check file-status file-success"></i>
                            <i v-if="!submitted" class="el-icon-close file-remove" :class="{ disabled: file.uploading }" @click="handleFileRemove(file, item)"></i>
                          </li>
                        </ul>
                      </div>
                    </el-form-item>
                  </template>
                </template>

                <!-- 修改：展示已上传资料，仅重新选择需替换的文件，其他文件保留 -->
                <template v-else>
                  <el-form-item label="上传资料" class="upload-item-form">
                    <div class="upload-item-row upload-info">请按要求上传以下资料：</div>
                  </el-form-item>
                  <el-form-item v-for="item in configFiles" :prop="item.configFileId" :key="item.configFileId" :label="item.fileName" :rules="[{ required: item.requiredFlag, message: '请选择', trigger: 'change' }]" class="upload-item-form">
                    <div class="upload-item-content">
                      <div class="upload-item-row">
                        <el-upload action="" multiple :auto-upload="false" :show-file-list="false" :disabled="submitted || (item.maxCount != null && item.files.length >= Number(item.maxCount))" :accept="formatExtensions(item.fileExtensions)" :on-change="file => handleFileChange(file, item)">
                          <el-button size="mini" type="primary" plain :disabled="submitted || (item.maxCount != null && item.files.length >= Number(item.maxCount))">选择文件</el-button>
                        </el-upload>
                        <span class="upload-file-name" v-if="item.files.length">{{ `已选择 ${item.files.length} 个文件` }}</span>
                        <span class="upload-file-name" v-else style="color: #999">未选择任何文件</span>
                      </div>
                      <!-- 已选文件列表（支持多文件，可单个删除） -->
                      <ul v-if="item.files.length" class="selected-files">
                        <li v-for="(file, fIdx) in item.files" :key="file.uid || file.fileId || file.id || fIdx">
                          <i class="el-icon-document"></i>
                          <span class="file-name" :title="file.fileName">{{ file.fileName }}</span>
                          <span class="file-size">{{ formatSize(file.size) }}</span>
                          <i v-if="file.uploading" class="el-icon-loading file-status"></i>
                          <i v-else-if="file.uploadError" class="el-icon-warning-outline file-status file-error"></i>
                          <i v-else class="el-icon-circle-check file-status file-success"></i>
                          <i v-if="!submitted" class="el-icon-close file-remove" :class="{ disabled: file.uploading }" @click="handleFileRemove(file, item)"></i>
                        </li>
                      </ul>
                    </div>
                  </el-form-item>
                </template>

                <div style="font-size: 13px; color: #8a97a6">请按资料名称分别上传，标 * 的项目为首次提交必填；暂不放行通知书需在提交船代前补齐。</div>
              </el-col>
            </el-row>

            <!-- 操作按钮 -->
            <div class="form-footer">
              <el-button size="small" :disabled="submitted" @click="handleReset">重置</el-button>
              <el-button v-if="!submitted" size="small" type="primary" plain :loading="loading" :disabled="isUploading" @click="() => handleSubmit('draft')">暂存草稿</el-button>
              <el-button size="small" type="primary" :loading="loading" :disabled="submitted || isUploading" @click="() => handleSubmit('submit')">{{ isEdit ? '确认修改' : '确认提交' }}</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>

    <div class="application-main" v-else>
      <div class="application-card">
        <div class="card-body">
          <div style="display: flex; align-items: center; justify-content: center"><i class="el-icon-warning" style="font-size: 32px; color: #f00"></i></div>
          <div style="display: flex; align-items: center; justify-content: center; margin-top: 12px">{{ isSubmitErrorText }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { CPSURL } from '@/utils/appContent'
import { oss_url } from '@/utils'
// import { getAgent, getBidConfig, submitBidBill, updateBidBill, uploadBidBillFile, submitBidBillDraft } from '@/api/common'

// ===== 提交 / 修改落货申请接口来自 @/api/common（submitBidBill / updateBidBill） =====

export default {
  name: 'DeliveryApplication',
  data() {
    return {
      oss_url,
      loading: false,
      submitted: false,
      form: {
        bidType: '',
        shipAgent: '',
        shipAgentShow: '',
        houseBillNo: '',
        remark: '',
        relatedHouseBillNos: '',

        textInputValues: {
          zhongLianNotShippedTarget: '',
          notShippedReason: '',
          unloadReason: '',
          customsDeclarationNo: '',
          declarationNo: '',
          auditReceiptNo: ''
        }
      },
      configInfo: null,
      // 上传资料项（修改模式）
      configFiles: [],
      rules: {
        shipAgent: [{ required: true, message: '请选择船代', trigger: 'change' }],
        houseBillNo: [{ required: true, message: '请输入分提单号', trigger: ['blur'] }],
        'textInputValues.zhongLianNotShippedTarget': [{ required: true, message: '请选择未上船证明版本', trigger: ['change'] }],
        'textInputValues.notShippedReason': [{ required: true, message: '请输入未出运原因', trigger: ['blur'] }],
        'textInputValues.unloadReason': [{ required: true, message: '请输入落货申请原因', trigger: ['blur'] }],
        'textInputValues.customsDeclarationNo': [{ required: true, message: '请输入报关单号', trigger: ['blur'] }],
        'textInputValues.declarationNo': [{ required: true, message: '请输入申报编号', trigger: ['blur'] }],
        'textInputValues.auditReceiptNo': [{ required: true, message: '请输入审核回执号', trigger: ['blur'] }]
      },

      // 船代
      agentList: [],
      agentListDict: {},

      isSubmitError: false,
      isSubmitErrorText: '',

      notShippedReasonText: {
        SH_WAI_DAI: '未上船原因 该未上船原因仅用于《未上船证明》',
        SH_SHUN_DE: '未上船原因',
        SH_LIAN_HE: '未上船原因',
        DF_HAI_WAI: '未上船原因 该未上船原因仅用于《未上船证明》'
      }
    }
  },
  created() {
    // this.getAgentList()
    this.getConfig()
  },
  computed: {
    // 是否为修改模式（替换原链接中的 configInfo.mode == 'NEW' 判断）
    isEdit() {
      return this.configInfo && this.configInfo.mode != 'NEW'
    },
    // 上传资料列表（供校验/提交统一引用，兜底为空数组）
    uploadList() {
      return this.configFiles || []
    },
    // 是否仍有文件正在上传
    isUploading() {
      return (this.configFiles || []).some(item => (item.files || []).some(f => f.uploading))
    }
  },
  methods: {
    // 获取船代
    async getAgentList() {
      const res = await getAgent()
      if (res) {
        // 仅展示指定船代（按 code 精确过滤，避免误包含外代博等相似项）
        const allowedCodes = [
          'SH_ZHONG_LIAN', // 上海中联
          'SH_ZHEN_HUA', // 上海振华
          'SH_ZHONG_WAI_YUN', // 上海外运
          'SH_WAI_DAI', // 上海外代
          'SH_SHUN_DE', // 上海顺德
          'SH_LIAN_HE', // 上海联合
          'DF_HAI_WAI' // 东方海外
        ]
        const list = res.filter(d => allowedCodes.includes(d.code))
        let arr = []
        list.map(d => {
          arr.push({ label: d.nameCn, value: d.code })
        })
        this.agentList = arr
        let dict = {}
        arr.forEach(d => {
          dict[d.value] = d.label
        })
        this.agentListDict = dict
      }
    },

    // 根据Token获取配置信息
    async getConfig() {
      let token = this.$route.query?.token
      this.loading = true
      try {
        const resp = await axios.post(`${CPSURL}/ccam/bid/submission/client/token/${token}`)
        const res = resp.data
        this.loading = false
        // 资料配置项：保留 key / files / existingName 等前端所需字段（不可直接用 res.configFiles 覆盖）
        this.configFiles = (res.configFiles || []).map(f => ({
          ...f,
          key: f.key || f.configFileId,
          label: f.fileName,
          files: f.files || [],
          existingName: f.existingName || ''
        }))
        // 已存在的上传文件同步到表单，避免编辑模式必填校验不通过
        this.configFiles.forEach(item => {
          this.$set(this.form, item.key, item.files)
        })

        // 回显表单已有值
        const form = this.form
        form.shipAgent = res.shipAgent
        form.shipAgentShow = res.shipAgentShow
        form.houseBillNo = res.houseBillNo
        form.remark = res.remark
        form.bidType = res.bidType
        form.relatedHouseBillNos = res.relatedHouseBillNos ? res.relatedHouseBillNos.join(',') : ''

        form.textInputValues = {
          zhongLianNotShippedTarget: res.textInputValues.zhongLianNotShippedTarget,
          notShippedReason: res.textInputValues.notShippedReason,
          unloadReason: res.textInputValues.unloadReason,
          customsDeclarationNo: res.textInputValues.customsDeclarationNo,
          declarationNo: res.textInputValues.declarationNo,
          auditReceiptNo: res.textInputValues.auditReceiptNo
        }

        this.configInfo = res
      } catch (error) {
        this.isSubmitError = true
        this.isSubmitErrorText = error.response?.data?.msg
        this.loading = false
      }
    },

    // 选择文件（支持多选，每次 on-change 回调一个文件）
    // 选中所选文件立即调用上传接口，成功后保存返回的文件信息（fileId / fileUrl 等）
    async handleFileChange(file, item) {
      // 同一文件不重复添加
      if (item.files.some(f => f.name === file.name && f.size === file.size)) {
        this.$message.warning(`「${file.name}」已在已选列表中`)
        return
      }
      // 数量限制：已达上限则拦截（预加载的已上传文件也计入数量）
      if (item.maxCount != null && item.files.length >= Number(item.maxCount)) {
        this.$message.warning(`「${item.fileName}」最多上传 ${item.maxCount} 个文件`)
        return
      }
      // 大小限制：超过 maxSize（字节）则拦截
      if (item.maxSize != null && item.maxSize != '0' && file.size > Number(item.maxSize)) {
        this.$message.warning(`「${file.name}」大小超出限制，最大 ${this.formatSize(Number(item.maxSize))}`)
        return
      }
      // 构造本地文件对象，便于维护上传状态
      const localFile = {
        uid: file.uid,
        name: file.name,
        fileName: file.name,
        size: file.size,
        raw: file.raw,
        uploading: true,
        uploadError: false,
        uploadResult: null
      }
      item.files.push(localFile)
      // el-upload 不会触发 el-form 的校验事件，需手动同步表单值并清除该项错误提示
      this.$set(this.form, item.key, item.files)
      this.$refs.form.clearValidate([item.key])

      try {
        const formData = new FormData()
        formData.append('file', file.raw)
        const res = await axios({
          url: `${CPSURL}/ccam/bid/submission/client/upload`,
          method: 'post',
          data: formData,
          params: {
            configFileId: item.configFileId,
            shipAgent: this.form.shipAgent,
            token: this.$route.query?.token
          }
        })
        // 业务异常（HTTP 200 但 code 非成功），需将 msg 提示出来
        if (!this.isBizSuccess(res)) {
          localFile.uploading = false
          localFile.uploadError = true
          this.$message.error(res.msg || '上传失败，请重新选择')
          return
        }
        // 兼容 {code,msg,data} 包装与直接返回对象两种情况，统一取业务数据
        localFile.uploadResult = this.getBizData(res)
        localFile.uploading = false
      } catch (e) {
        localFile.uploading = false
        localFile.uploadError = true
        this.$message.error(`「${file.name}」上传失败，请重新选择`)
      }
    },

    // 删除单个已选文件
    handleFileRemove(file, item) {
      if (file.uploading) return
      const index = item.files.indexOf(file)
      if (index > -1) item.files.splice(index, 1)
      this.$set(this.form, item.key, item.files.length ? item.files : null)
    },

    // 格式化文件大小
    formatSize(size) {
      if (!size) return ''
      if (size < 1024) return size + ' B'
      if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB'
      return (size / 1024 / 1024).toFixed(1) + ' MB'
    },

    // 将 "docx,doc" 转为 accept 可用的 ".docx,.doc" 格式（自动补点号）
    formatExtensions(ext) {
      if (!ext) return ''
      return ext
        .split(',')
        .map(e => e.trim())
        .filter(Boolean)
        .map(e => (e.startsWith('.') ? e : '.' + e))
        .join(',')
    },

    // 重置：首次提交清空表单，修改还原为原数据
    handleReset() {
      let base = { bidType: this.configInfo.bidType, shipAgent: this.configInfo.shipAgent, shipAgentShow: this.configInfo.shipAgentShow, houseBillNo: this.configInfo.houseBillNo, remark: '' }
      base.textInputValues = { zhongLianNotShippedTarget: '', notShippedReason: '', unloadReason: '', customsDeclarationNo: '', declarationNo: '', auditReceiptNo: '' }
      this.form = base
      this.uploadList.forEach(item => {
        item.files = []
        this.$set(this.form, item.key, null)
      })
      this.$nextTick(() => this.$refs.form.clearValidate())
    },

    // 提交 / 修改：调用真实接口
    async handleSubmit(type) {
      // 文件仍在上传中时，禁止提交
      if (this.isUploading) {
        this.$message.warning('文件上传中，请稍候')
        return
      }

      if (type == 'draft') {
        let files = []
        this.uploadList.map(item => {
          let fileArr = []
          item.files.map(file => {
            fileArr.push(file.uploadResult || file)
          })

          files = files.concat(fileArr)
        })

        // this.loading = true
        // 组装 BidSubmissionSubmitParam
        const payload = JSON.parse(
          JSON.stringify({
            houseBillNo: this.form.houseBillNo,
            draftJson: {
              shipAgent: this.form.shipAgent,
              houseBillNo: this.form.houseBillNo,
              remark: this.form.remark,
              textInputValues: { ...this.form.textInputValues },
              files
            }
          })
        )

        try {
          const resp = await axios.post(`${CPSURL}/ccam/bid/submission/client/token/${this.$route.query?.token}/draft`, payload)
          const res = resp.data
          // 业务异常（HTTP 200 但 code 非成功），需将 msg 提示出来
          if (!this.isBizSuccess(res)) {
            this.$message.error(res.msg || '提交失败，请稍后重试')
            this.loading = false
            return
          }
          this.loading = false
          this.$message.success('保存草稿成功～')
          console.log('提交结果：', this.getBizData(res))
        } catch (e) {
          this.$message.error(e.response?.data?.msg)
          this.loading = false
        }
      }
      //
      else {
        // 修改模式：必填资料未重新上传且原文件缺失时，拦截提交
        if (this.isEdit) {
          const missing = this.uploadList.filter(item => item.requiredFlag && !item.files.length)
          if (missing.length) {
            this.$message.warning(`请上传：${missing.map(i => i.label).join('、')}`)
            return
          }
        }

        let files = []
        this.uploadList.map(item => {
          let fileArr = []
          item.files.map(file => {
            fileArr.push(file.uploadResult || file)
          })

          files = files.concat(fileArr)
        })

        this.$refs.form.validate(async valid => {
          if (!valid) return
          this.loading = true
          // 组装 BidSubmissionSubmitParam
          const payload = JSON.parse(
            JSON.stringify({
              token: this.$route.query?.token,
              shipAgent: this.form.shipAgent,
              houseBillNo: this.form.houseBillNo,
              remark: this.form.remark,
              textInputValues: { ...this.form.textInputValues },
              files
            })
          )

          try {
            const api = this.isEdit ? `${CPSURL}/ccam/bid/submission/client/update` : `${CPSURL}/ccam/bid/submission/client/submit`
            const resp = await axios.post(api, payload)
            const res = resp.data
            // 业务异常（HTTP 200 但 code 非成功），需将 msg 提示出来
            if (!this.isBizSuccess(res)) {
              this.$message.error(res.msg || '提交失败，请稍后重试')
              this.loading = false
              return
            }
            this.loading = false
            this.submitted = true
            this.$message.success(this.isEdit ? '修改成功，等待客服审批～' : '提交成功，等待客服审批～')
            console.log('提交结果：', this.getBizData(res))
          } catch (e) {
            this.$message.error(e.response?.data?.msg)
            this.loading = false
          }
        })
      }
    },

    // 该后端接口以 HTTP 200 + 业务 code 标识结果，成功码为 0 / 200（也可能直接返回数据而无 code）
    isBizSuccess(res) {
      if (!res || res.code === undefined) return true
      return [0, 200, '0', '200'].includes(res.code)
    },

    // 提取业务数据：兼容 {code,msg,data} 包装与直接返回对象两种情况
    getBizData(res) {
      return res && res.data !== undefined ? res.data : res
    },

    // 构造单个配置项下的文件参数数组（BidSubmissionUploadFileParam[]）
    // 新上传文件使用上传接口返回信息；编辑模式未重新选择的沿用服务端已返回的文件
    buildItemFiles(item) {
      if (item.files && item.files.length) {
        return item.files.map(file => {
          const res = file.uploadResult
          const param = { configFileId: item.configFileId }
          if (file.raw) param.contentType = file.raw.type
          if (res) {
            // 新上传文件
            param.fileId = res.fileId
            param.fileName = res.fileName
            param.fileSize = res.fileSize
            param.fileUrl = res.fileUrl
            param.id = res.id
            param.originalFileName = res.originalFileName
            if (res.fileExt) param.fileExt = res.fileExt
          } else {
            // 编辑模式沿用已上传文件
            if (file.fileId) param.fileId = file.fileId
            if (file.id) param.id = file.id
            if (file.fileName) param.fileName = file.fileName
            if (file.fileSize) param.fileSize = file.fileSize
            if (file.fileUrl) param.fileUrl = file.fileUrl
            if (file.fileExt) param.fileExt = file.fileExt
            if (file.contentType) param.contentType = file.contentType
          }
          if (!param.originalFileName) param.originalFileName = file.name
          return param
        })
      }
      // 未重新选择时沿用已上传文件（编辑模式，仅已知原始文件名）
      if (item.existingName) {
        return [{ configFileId: item.configFileId, originalFileName: item.existingName }]
      }
      return []
    },

    // 联系客服
    openQQ() {
      window.open('https://wpa1.qq.com/yGWcFLfo?_type=wpa&qidian=true')
    }
  }
}
</script>

<style lang="scss" scoped>
@use './style.scss';
</style>
